import React from 'react';
import { formatDistanceToNowStrict } from 'date-fns';
import { vi } from 'date-fns/locale';
import CommentAvatar from './CommentAvatar';
import rankName from '../../utils/user/rankName';
// Link trong trả lời (QTV rep kèm link) phải bấm được — dùng chung renderer với bài đăng
import { renderLinkified } from '../../pages/Community/community-linkified-text';
import { splitLeadingMention } from './comment-mention';

function ReplyItem({
    reply,
    commentId,
    isLogined,
    userInfo,
    isHighlighted,
    onOpenReply,
    onDeleteReply,
    knownNames = [],
}) {
    // "@Tên" đứng đầu nội dung → tách ra tô màu cho nổi (kiểu Facebook)
    const { mention, rest } = splitLeadingMention(reply.comment, knownNames);
    const isAdmin = reply.user?.role === 'admin';
    // Chỉ admin xoá được (user không xoá/sửa trả lời của mình sau khi gửi).
    const canDelete = isLogined && userInfo.role === 'admin';

    return (
        <div
            id={`reply-${reply.id}`}
            /* before:* vẽ "khuỷu" nối ngang từ đường dọc của khối trả lời
               (border-l ở CommentItem) sang avatar — nhìn là biết reply
               thuộc bình luận nào. top canh giữa avatar 28px + py-2. */
            className={`relative flex gap-2 py-2 rounded-xl transition-colors duration-700
                before:absolute before:top-[22px] before:h-0.5 before:bg-surface-raised
                before:-left-5 before:w-3 sm:before:-left-8 sm:before:w-6 ${
                    isHighlighted ? 'bg-primary-50' : ''
                }`}
        >
            <CommentAvatar avatar={reply.user?.avatar} isAdmin={isAdmin} size="sm" />
            <div className="flex-1 min-w-0">
                <div
                    className={`inline-block max-w-full rounded-2xl px-3 py-2 ${
                        isAdmin ? 'bg-amber-50 border border-amber-200' : 'bg-surface-muted'
                    }`}
                >
                    <div className="flex flex-wrap gap-1 items-center">
                        <span className="font-semibold text-sm text-content">
                            {reply.user?.name || `user-${reply.user?.userId}`}
                        </span>
                        <span className="text-xs">
                            {isAdmin ? rankName(888) : rankName(reply.user?.rank)}
                        </span>
                    </div>
                    <p className="text-sm text-content-2 whitespace-pre-wrap break-words">
                        {mention && (
                            <span className="font-semibold text-primary-600">
                                @{mention}{' '}
                            </span>
                        )}
                        {renderLinkified(rest)}
                    </p>
                </div>
                <div className="flex items-center gap-1 mt-1 px-1">
                    <span className="text-xs text-content-3 mr-1">
                        {formatDistanceToNowStrict(reply.createTime, { locale: vi })}
                    </span>
                    {isLogined && (
                        <>
                            <button
                                type="button"
                                onClick={() => onOpenReply(commentId, reply.user?.name)}
                                className="text-xs text-content-3 hover:text-primary-500 font-medium px-1.5 py-1.5 rounded"
                            >
                                Trả lời
                            </button>
                            {canDelete && (
                                <button
                                    type="button"
                                    onClick={() => onDeleteReply(reply.id)}
                                    className="text-xs text-content-3 hover:text-primary-500 font-medium px-1.5 py-1.5 rounded"
                                >
                                    Xoá
                                </button>
                            )}
                        </>
                    )}
                </div>
            </div>
        </div>
    );
}

export default ReplyItem;
